import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { submitForm } from 'b2b-apps/shop/content/redux/forms/actionCreators';
import { FormDataType } from 'b2b-apps/shop/content/redux/forms/types';

type UseSubmitFormActionReturnType = (
  formId: string,
  data: FormDataType,
) => void;

const useSubmitFormAction = (): UseSubmitFormActionReturnType => {
  const dispatch = useDispatch();

  return useCallback(
    (formId: string, data: FormDataType): void => {
      dispatch(submitForm(formId, data));
    },
    [dispatch],
  );
};

export { useSubmitFormAction };
export type { UseSubmitFormActionReturnType };
